import React, { useState } from "react";
import { toast } from "react-toastify";

/**
 * Campo somente-leitura com a URL do feed e botão de copiar.
 * Mesma mecânica de cópia usada na tela de API externa.
 */
export const CopyableUrl = ({ url }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (!url) return;
        navigator.clipboard.writeText(url).then(() => {
            setCopied(true);
            toast.success("URL copiada!");
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="feed-url">
            <span className="feed-url__value" onClick={handleCopy} title="Clique para copiar">
                {url}
            </span>
            <button
                type="button"
                className={`feed-url__copy${copied ? " copied" : ""}`}
                onClick={handleCopy}
                title="Copiar"
            >
                {copied ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                )}
            </button>
        </div>
    );
};

export default CopyableUrl;
